import { render, staticRenderFns } from "./AttivaUtente.vue?vue&type=template&id=34ba5a1e&"
import script from "./AttivaUtente.vue?vue&type=script&lang=js&"
export * from "./AttivaUtente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports